import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { responseError } from '../../../helpers/response/ResponseHelper'
import SupplierTable from './SupplierTable'
import { getSuppliersAPI } from '../../../api/supply/supplierAPI'
import { useDispatch, useSelector } from 'react-redux'
import { setSuppliersCount, setSuppliersLimit, setSuppliersList, setSuppliersOffset } from '../../../store/supplierSlice'

const SupplierList = () => {

    const suppliers = useSelector(state => state.supplier.suppliers.list)
    const count = useSelector(state => state.supplier.suppliers.count)
    const limit = useSelector(state => state.supplier.suppliers.limit)
    const offset = useSelector(state => state.supplier.suppliers.offset)
    const query = useSelector(state => state.supplier.suppliers.query)
    const dispatch = useDispatch()
    // const [count, setCount] = useState(0)
    // const [limit, setLimit] = useState(10)
    // const [offset, setOffset] = useState(0)
    // const [query, setQuery] = useState('')

    // const [suppliers, setSuppliers] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        
        // Функція для затримки
        const handler = setTimeout(() => {
            getSuppliers()
        }, 300) // 300 мс затримки

        return () => clearTimeout(handler)

    }, [limit, offset, query])

    const getSuppliers = () => {
        setLoading(true)
        setError('')
        getSuppliersAPI({ offset, limit, query }).then(data => {
            // setCount(data.count)
            // setSuppliers(data.suppliers)
            dispatch(setSuppliersCount(data.count))
            dispatch(setSuppliersList(data.suppliers))
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div>
        <SupplierTable
            suppliers={suppliers}
            count={count}
            limit={limit}
            setLimit={e => dispatch(setSuppliersLimit(e))}
            offset={offset}
            setOffset={e => dispatch(setSuppliersOffset(e))}
            loading={loading}
        />
    </div>
  )
}

export default SupplierList